import {
  CreatedRecords,
  ScenarioHelpInfo,
  ScenarioOptionsType,
} from "../../types/scenario-group.types";
import { TransactionView } from "@bitwarden/web-vault/app/models/view/transaction/transaction.view";

export class ScenarioDisplayView {
  ScenarioGroupId: string;
  scenarioID: string;
  scenarioType: ScenarioOptionsType;
  scenarioName: string;
  createdRecords: CreatedRecords;
  fullTransactionList: Array<TransactionView>;
  transactionBalances?: Record<string, number>;
  finalBalanceAmount: number;
  graphDates?: Array<number>;
  graphBalances?: Array<number>;
  helpInfo?: ScenarioHelpInfo;
}
